module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#gallery",
      toString: function () {
        return this.url;
      }
    }